import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Right } from '../entities/right';

/**
 * Base url
 */
const BASE_URL = 'users/rights/';

/**
 * Rights service
 */
@Injectable({
  providedIn: 'root',
})
export class RightService {
  /**
   * Constructor
   *
   * @param apiService ApiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * List
   *
   * @param name User name
   *
   * @returns Observable with rights
   */
  list(name: string): Observable<Right[]> {
    return this.apiService.get(BASE_URL.concat(name)).pipe(map((rights) => rights.map((right: any) => Right.createFromJson(right))));
  }

  /**
   * Update
   *
   * @param right Right
   *
   * @returns Observable
   */
  update(right: Right): Observable<any> {
    return this.apiService.put(`${BASE_URL}update`, right);
  }
}
